export default __webpack_public_path__ + "static/media/coinbase-logo.cc4948d7.png";